import { CartAddEvent, CartGroupedSections, ThemeEvents } from "@theme/events";
import { fetchConfig } from "@theme/utilities";

class CartLastMinuteEssentials extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  #onClick = async (event) => {
    const button = event.target.closest("[data-cart-essentials-add]");
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add("btn--loading");

    const sectionIds = [];
    document.dispatchEvent(new CartGroupedSections(sectionIds));

    try {
      const response = await fetch(
        FoxTheme.routes.cart_add_url,
        fetchConfig("json", {
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: [...new Set(sectionIds)].join(","),
            sections_url: window.location.pathname,
          }),
        })
      );
      const cart = await response.json();

      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || "Unable to add item");
      }

      this.dispatchEvent(
        new CartAddEvent(cart, this.id || "cart-last-minute-essentials", {
          source: "cart-last-minute-essentials",
          itemCount: 1,
          variantId,
          sections: cart.sections,
        })
      );
      document.dispatchEvent(new CustomEvent(ThemeEvents.productAjaxAdded, { detail: { product: cart } }));
    } catch (error) {
      console.error("Cart essentials add failed:", error);
      button.disabled = false;
      button.classList.remove("btn--loading");
    }
  };
}

if (!customElements.get("cart-last-minute-essentials")) {
  customElements.define("cart-last-minute-essentials", CartLastMinuteEssentials);
}
